import { render, staticRenderFns } from "./AdvanceReceiptDetail.vue?vue&type=template&id=2b5e47ff&scoped=true"
import script from "./AdvanceReceiptDetail.vue?vue&type=script&lang=js"
export * from "./AdvanceReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./AdvanceReceiptDetail.vue?vue&type=style&index=0&id=2b5e47ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e47ff",
  null
  
)

export default component.exports